const vndCurrency = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' });
const vndNumber = new Intl.NumberFormat('vi-VN');

export function toNumber(value: unknown): number {
  if (value == null) return 0;
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  if (typeof value === 'string') return Number(value) || 0;
  if (typeof value === 'object') {
    const record = value as Record<string, unknown>;
    if (typeof record.$numberDecimal === 'string') {
      return Number(record.$numberDecimal) || 0;
    }
    if (typeof record.value === 'string' || typeof record.value === 'number') {
      return Number(record.value) || 0;
    }
  }
  return Number(value) || 0;
}

export function formatVND(n: unknown): string {
  return vndCurrency.format(toNumber(n));
}

export function formatNumber(n: unknown): string {
  return vndNumber.format(toNumber(n));
}

export function formatDate(iso: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('vi-VN');
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDateTimeFull(iso: string): string {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
